import SearchComponent from './SelectComponent';
export * from './SelectComponent';
export default SearchComponent;
